module.exports = __webpack_public_path__ + "media/components/weather-icon/static/nightmodsnow-4f4040e070a1d120029f828473ac9395.webp";